import  {RoadStake} from "../models/RoadStake";
import  {RoadUnit} from "../models/RoadUnit";
import {
  CARD1Web, MouseAction
} from '../CoordUtils.js';

export class RoadModel {
  constructor(data, roadType, roadName, sceneManager) {
    this.model = new Object();
    this.model.roadunits = new Array();
    this.model.roadunitMap = new Object();
    this.model.roadStake = new Array();
    this.model.roadStakeMap = new Object();
    this.sceneManager = sceneManager;
    var roadData = data.roadData;
    this.stakeInterval = roadData[1].stakeval - roadData[0].stakeval; 
    this.buildRoadModel(data.roadData);
    this.laneNo = data.laneNo;
    this.guardRails = data.guardRails;
    this.mediaDividers = data.mediaDividers;
    this.rampData = data.rampData;

    this.roadType = roadType; //0:主道， 1：匝道
    
    this.roadName = roadName;
    this.roadId = data.roadId;
  }

 buildRoadModel(roadData) {
    var roadStakes = [];
    var roadDataLength = roadData.length;
    //分别求出该段落前面和后面的桩号
    for (let i = 0; i < roadDataLength; i++){    
      if (this.getRoadUnitByStakeVal(roadData[i].stakeval)) continue;
      var lastStakeNo = roadData[i].stakeval - this.stakeInterval;
      if (this.getRoadStake(lastStakeNo) == undefined){
        var end = roadData[i+1];
        end.center = new Object();
        end.center.z = end.gisData.longtitude - this.sceneManager.CoordOffset.lon;
        end.center.x = end.gisData.latitude - this.sceneManager.CoordOffset.lat;
        end.center.y = (end.leftRootHeight + end.rightRootHeight) / 2;
        var startStake = new RoadStake(roadData[i], this.sceneManager.CoordOffset, roadData[i+1]);
        this.addStake(startStake);
      }  
      else{
          var stake = new RoadStake(roadData[i], this.sceneManager.CoordOffset, this.getRoadStake(lastStakeNo));    
          this.addStake(stake);
      }   
    }
    //sort roadstake and roadunit
    var helper = new CARD1Web.CoordUtils.Helper();
    this.model.roadStake = helper.fastSort(this.model.roadStake, "stakeval");
    this.model.roadunits = helper.fastSort(this.model.roadunits, "stakeval");
    // this.markRoadOnMap(this.sceneManager.webView);
  }

  getAllStakes() {
    return this.model.roadStake;
  }
  getStartStake() {
    return this.model.roadStake[0];
  }

  getEndStake() {
    return this.model.roadStake[this.model.roadStake.length - 1];
  }

  getRoadUnitByStakeVal(stakeval) {
    return this.model.roadunitMap[stakeval];
  }

  addStake(roadStake){
    this.model.roadStake.push(roadStake);
    this.model.roadStakeMap[roadStake.stakeval] = roadStake;
    var lastStakeNo = roadStake.stakeval - this.stakeInterval;
    var lastStake = this.getRoadStake(lastStakeNo);
    if (lastStake != undefined && (this.model.roadunitMap[lastStake.stakeval] == undefined)){
      var roadUnit = new RoadUnit(lastStake, roadStake);
      this.model.roadunits.push(roadUnit);
      this.model.roadunitMap[lastStake.stakeval] = roadUnit;  
    }
  }

  getRoadStake(stakeval){
    return this.model.roadStakeMap[stakeval];
  }

  getStakesByRange(stakeRange){
    var cursor = stakeRange.start;
    var roadStakes = [];
    while (cursor <= stakeRange.end){
      roadStakes.push(this.getRoadStake(cursor));
      cursor += this.stakeInterval;
    }
    return roadStakes;
  }

}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/models/RoadModel.js